import { flex } from '@flipster/styled-system/patterns';

import { EarnSunsetPhaseOverride } from './earn-sunset-phase';
import { FeatureFlag } from './feature';

export const Flag = () => {
  return (
    <div
      className={flex({
        flexDir: { base: 'column', tablet: 'row' },
        minH: 0,
        flex: 1,
        align: 'stretch',
        gap: { base: 20, tablet: 8 },
        p: 8,
        pb: 60,
      })}
    >
      <div className={flex({ flexDir: 'column', flex: 1, minH: 0, gap: 16, overflowY: 'auto' })}>
        <EarnSunsetPhaseOverride />
        <FeatureFlag />
      </div>
    </div>
  );
};
